import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtFooter, setIsAtFooter] = useState(false);
  const [containerOffset, setContainerOffset] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);

      const footer = document.querySelector("footer");
      const container = document.querySelector(".container-section");
      if (footer && container) {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        setIsAtFooter(footerRect.top <= windowHeight - 50);

        // Hitung posisi kanan dari container supaya tetap sejajar
        const containerRect = container.getBoundingClientRect();
        const rightSpace = window.innerWidth - containerRect.right;
        setContainerOffset(rightSpace > 0 ? rightSpace : 0);
      }
    };

    handleScroll(); // jalankan sekali saat load
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      style={{
        right: isAtFooter
          ? `${(containerOffset ?? 0) + 10}px` 
          : `${(containerOffset ?? 0) + 10}px`,
        bottom: isAtFooter ? "24px" : "24px",
        top: isAtFooter ? "auto" : "auto",
        position: isAtFooter ? "fixed" : "fixed",
      }}
      className="z-0 bg-[#123b7c] text-white p-3 rounded-full shadow-lg hover:bg-[#0e2f66]"
    >
      <ArrowUp size={20} />
    </button>
  );
}
